import { PatientTreatmentDetailListResponseDto } from "@/data/dto/patient-treatement-detail-list/patient-treatment-detail-list-reponse-dto copy";
import { PatientTreatmentListEntity } from "@/domain/entity/treatment/patient-treatment-detail-info-list-entity";
import { formatLocalToYyyyMmDd } from "@/utils/date-util";
import { getTreatmentState } from "@/utils/enum/treatment-state-enum";
import { assertPatientTreatmentDetailListResponseDto } from "@/utils/validation/generated/patient-treatment-detail-list-response-dto.validator";

export class PatientTreatmentDetailInfoListMapper {
  static toEntity(dto: PatientTreatmentDetailListResponseDto): PatientTreatmentListEntity {
    assertPatientTreatmentDetailListResponseDto(dto);

    // console.log("[PatientTreatmentDetailInfoListMapper] :: toEntity :: ", dto);
    const playedTime = parseInt(dto.actuallyPlayTime.toString());
    const startDate = new Date(dto.startDate);
    const endDate = new Date(dto.endDate);

    const dailyProgress =
      dto.recommendedExecutedDay > 0
        ? Math.round((dto.actuallyExecutedDay / dto.recommendedExecutedDay) * 100)
        : 0;

    const adherence =
      dto.actuallyPlayTime > 0 && dto.recommendedTotalPlayTime > 0
        ? Number(((dto.actuallyPlayTime / dto.recommendedTotalPlayTime) * 100).toFixed(1))
        : 0;

    return {
      uuid: dto.treatmentInfoUuid,
      stepInfo: {
        step: dto.step,
        treatmentId: dto.treatmentInfoUuid,
      },
      period: {
        start: formatLocalToYyyyMmDd(startDate),
        end: formatLocalToYyyyMmDd(endDate),
      },
      stateSummary: {
        state: getTreatmentState(dto.state),
        dailyProgress: dailyProgress,
      },
      activityTime: {
        performed: Math.floor(playedTime / 60),
        recommended: Math.floor(dto.recommendedTotalPlayTime / 60),
      },
      adherence: adherence,
      doctor: dto.doctorName,
    };
  }
}
